import { useRef, useEffect } from 'react';

function usePrevious<T>(value: T) {
  const ref = useRef<null | T>(null);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  // oxlint-disable-next-line react/refs -- intentional read of previous value pattern
  return ref.current;
}
export default usePrevious;
